import React from 'react';
import { CardTitle, CardBody, CardBodyGroup, CardBodyBold } from './styles';
import CONSTANTS from './constants';
import { CurrentAppConfig } from 'op-pages/RO/Careplan/AppConfig';
import { useReferrers } from '../constants';
import { Typography } from '@mui/material';

interface AllReferrers {
  id: string;
  relationshipType?: string;
  practitioner: {
    firstName: string;
    id: string;
    lastName: string;
    phone?: string;
    qualification?: string;
  };
}

interface Props {
  name: string;
  allReferrers: AllReferrers[];
}

const TreatmentTeamCard = ({ name, allReferrers }: Props): JSX.Element => {
  const { CONTACT, REFERRING } = CONSTANTS;
  const { responsiblePhysician, primaryPhysician, referringSurgeon } = useReferrers(allReferrers);

  return (
    <div data-testid="treatmentTeamCard">
      <CardTitle>{name}</CardTitle>
      <CardBody>
        <CardBodyGroup data-testid="responsiblePhysician">
          <Typography variant="body2" color="text.secondary">
            {CurrentAppConfig.ReferringPhysicians.oncologist}
          </Typography>
          <Typography variant="body2" color="text.primary">
            {responsiblePhysician
              ? `${responsiblePhysician.practitioner.firstName} ${responsiblePhysician.practitioner.lastName}`
              : '-'}
          </Typography>
        </CardBodyGroup>
        <CardBodyGroup data-testid="primaryPhysician">
          <Typography variant="body2" color="text.secondary">
            {CurrentAppConfig.ReferringPhysicians.generalPractitioner}
          </Typography>
          <Typography variant="body2" color="text.primary">
            {primaryPhysician
              ? `${primaryPhysician.practitioner.firstName} ${primaryPhysician.practitioner.lastName}`
              : '-'}
          </Typography>

          {primaryPhysician?.practitioner?.phone && (
            <Typography variant="body2" color="text.primary">
              {CONTACT}: {primaryPhysician.practitioner.phone}
            </Typography>
          )}
        </CardBodyGroup>
        {referringSurgeon.length > 0 ? (
          referringSurgeon.map((item: any, index: number) => (
            <CardBodyGroup key={`${item.practitioner.firstName}-${index}`} data-testid={`referringPhysician-${index}`}>
              <Typography variant="body2" color="text.secondary">
                {
                  CurrentAppConfig.ReferringPhysicians[
                    item.relationshipType as keyof typeof CurrentAppConfig.ReferringPhysicians
                  ]
                }
              </Typography>
              <Typography variant="body2" color="text.primary">
                {item.practitioner.firstName} {item.practitioner.lastName}
              </Typography>
              {item.practitioner.phone && (
                <Typography variant="body2" color="text.primary">
                  {CONTACT}: {item.practitioner.phone}
                </Typography>
              )}
            </CardBodyGroup>
          ))
        ) : (
          <CardBodyGroup>
            <Typography variant="body2" color="text.secondary">
              {REFERRING}
            </Typography>
            <Typography variant="body2" color="text.primary">
              -
            </Typography>
          </CardBodyGroup>
        )}
      </CardBody>
    </div>
  );
};

export default TreatmentTeamCard;
